import { atom } from 'jotai'

export const loadingUserConfigState = atom<'loading'|'loaded'>('loading');
